module.exports = "/images/close-tip.png?d17bb4b502f96c3471380a597b692814";


//////////////////
// WEBPACK FOOTER
// ./resources/images/expirePop/close-tip.png
// module id = RzMZ
// module chunks = 182